export class TagConstant {
    static UnTagged() {
        return "c3301c0a-6eb7-4f34-89e2-58608789a4e4";
    }
}
